import { type GuardArgs } from 'xstate/guards';

import { FetchInitialDataResponse, HandoffCartResponse } from './cart-handoff-machine.actors';
import { CartHandoffContext } from './cart-handoff-machine.context';
import { CartHandoffEvent } from './cart-handoff-machine.events';

// ─────────────────────────────────────────────────────────────────────────────

const checkIfHasOrderToken: CartHandoffGuard<FetchInitialDataResponse> = (_args, params) => {
  return Boolean(params.orderToken);
};

const checkIfWouldClearActiveBag: CartHandoffGuard<FetchInitialDataResponse> = (_args, params) => {
  return Boolean(params.orderToken) && Boolean(params.hasActiveBag);
};

const checkIfHasConflicts: CartHandoffGuard<HandoffCartResponse> = (_args, params) => {
  return Boolean(params.conflicts.length > 0);
};

const checkIfHasNothingAvailable: CartHandoffGuard<HandoffCartResponse> = (_args, params) => {
  return Boolean(params.hasNothingAvailable);
};

// ─────────────────────────────────────────────────────────────────────────────

export const CartHandoffGuards = {
  checkIfHasOrderToken,
  checkIfWouldClearActiveBag,
  checkIfHasConflicts,
  checkIfHasNothingAvailable,
};

// ─── Types ───────────────────────────────────────────────────────────────────

type CartHandoffGuard<Params extends Record<string, unknown> | void = void> = (
  args: GuardArgs<CartHandoffContext, CartHandoffEvent>,
  params: Params,
) => boolean;
